var WidgetDataController = require('./WidgetDataController.js').default;

function WidgetDataDirective($timeout, serviceUtility) {
	return {
		restrict: 'E',
		scope: {
			'model': '=ngModel',
			'store': '=',
			'onQueryChanged': '&',
			'onChange': '&',
			'onIntervalChange': '&',
			'isStream': '=',
			'queryValidation': '&'
			// 'disabled': '='
		},
		controller: WidgetDataController,
		require: 'ngModel',
		controllerAs: 'vm',
		templateUrl: '/package/system/dashboard/view.WidgetData.html',
		link: function(scope, el, attr, ctrl) {

			ctrl.$formatters.push(function(modelValue) {
				//scope.isDataSourceChanged = false;
				if(!modelValue) return;

				if(!modelValue.data) {
					modelValue.data = { query: '', source: { guid: null } };
				}

				if(!modelValue.data.query) {
					// subcommand 라는거 없앨거임
					modelValue.data.query = modelValue.data.source.subcommand;
					delete modelValue.data.source.subcommand;
				}

				if(!modelValue.interval) {
					modelValue.interval = 5;
				}

				if(serviceUtility.exists('data.source.guid', modelValue)) {
					scope.vm.selectedDataSource = scope.store.sources[modelValue.data.source.guid];
				}

				return modelValue;
			});

			scope.vm.ngModelController = ctrl;
			
			scope.$watch('isStream', function(newVal, oldVal){
				scope.showInterval = newVal;
			})
		}
	}
}

module.exports = WidgetDataDirective;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetDataDirective.js